import {
	Alert,
	Button,
	Card,
	Collapse,
	DatePicker,
	Flex,
	Form,
	Input,
	Modal,
	Select,
	Spin,
	Table,
	Tag,
	Typography,
	message,
	Row,
	Col,
} from "antd";
import dayjs from "dayjs";
import React from "react";
import copy from "copy-to-clipboard";
import { useEffect, useState } from "react";
import "./style.css";
import { useGetAllocationByDateQuery } from "@/redux/services/allocationApi";
import { useGetReleaseByDateQuery, useAddReleaseMutation, useUpdateReleaseMutation } from "@/redux/services/releaseApi";
import {
	useGetTemplatesQuery,
	useSendCsutomMessageMutation,
	useSendMessageWithPhoneMutation,
	useSendMessagesMutation,
	useSendMessageWithCusPhoneUpdatedMutation,
} from "@/redux/services/phoneTemplateApi";

const dateFormat = "YYYY-MM-DD";
const { Text, Title } = Typography;

function replacePlaceholders(template, data, selectedDate = "") {
	if (data.pickup_time) {
		data.pickup_time = selectedDate + " " + data.pickup_time;
	}

	template = template.replace("subtitle", "product_title");
	// 使用正则表达式匹配模板中的占位符
	const regex = /{{\s*(.*?)\s*}}/g;

	// 使用replace方法替换占位符
	const replacedString = template.replace(regex, (match, p1) => {
		// 从数据对象中获取与占位符对应的值
		const value = data[p1.trim()];
		// 如果找到了对应的值，则返回该值，否则返回原始占位符
		return value !== undefined ? value : match;
	});

	return replacedString;
}

export const ItemText = ({ text, value }) => {
	return (
		<div>
			<Text>
				{text} <Text style={{ fontSize: 12 }}> {value}</Text>
			</Text>
		</div>
	);
};

const FlexColumn = {
	display: "flex",
	flexDirection: "column",
	gap: "20px",
};

const cardWidth = 340; // 每个 Card 的固定宽度
const gutter = 6; // Card 之间的间距
const cardStyle = {
	width: cardWidth,
	marginBottom: gutter,
	marginRight: gutter,
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // 添加阴影效果
};

const CardItem = ({ list, selectTemplate, productTitle, selectedDate }) => {
	const getClientNumber = (items = []) => {
		return items.reduce((acc, curr) => {
			return acc + curr.people_no;
		}, 0);
	};

	const handleCopySMS = (item, vehicle, driver) => {
		if (selectTemplate == null) {
			message.warning("Please select template");
			return;
		}
		const text = replacePlaceholders(
			selectTemplate.template,
			{
				...item,
				...vehicle,
				...driver,
				...productTitle,
			},
			selectedDate
		);
		copy(text);
		message.success("已经复制接送汇总！");

		// navigator.clipboard
		// 	.writeText(text)
		// 	.then(() => {
		// 		message.success("Copied to clipboard!");
		// 	})
		// 	.catch((err) => {
		// 		message.warning("Failed to copy");
		// 		console.error("Failed to copy: ", err);
		// 	});
	};

	const mappingMessageDetail = (item, vehicle, driver) => {
		if (selectTemplate == null) {
			return;
		}
		return replacePlaceholders(
			selectTemplate.template,
			{
				...item,
				...vehicle,
				...driver,
				...productTitle,
			},
			selectedDate
		);
	};

	const calculateMsgStatus = (data) => {
		return data.reduce(
			(acc, item) => {
				if (item.is_msg === 0) {
					acc.unsent += 1;
				} else if (item.is_msg === 1) {
					acc.sent += 1;
				} else if (item.is_msg === 2) {
					acc.failed += 1;
				}
				return acc;
			},
			{ unsent: 0, sent: 0, failed: 0 }
		);
	};
	const messageStatue = [calculateMsgStatus(list?.items || [])];
	return (
		<>
			<Card style={cardStyle}>
				<div style={FlexColumn}>
					<div>
						<Title level={5}>车辆信息</Title>
						<Card>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "5px",
								}}
							>
								<ItemText
									text={"车牌："}
									value={list.vehicle.vehicle_plate_number}
								/>
								<ItemText
									text={"总座位："}
									value={list.vehicle.vehicle_total_seats}
								/>
								<ItemText
									text={"空余座位："}
									value={list.vehicle.vehicle_available_seats}
								/>
								<ItemText
									text={"品牌："}
									value={list.vehicle.vehicle_model}
								/>
								<ItemText
									text={"颜色："}
									value={list.vehicle.vehicle_color}
								/>
							</div>
						</Card>
					</div>
					{/* <Divider /> */}
					<div>
						<Title level={5}>司机信息</Title>
						<Card>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "5px",
								}}
							>
								<ItemText
									text={"名字："}
									value={
										list?.driver?.driver_name ?? "未分配"
									}
								/>

								<ItemText
									text={"电话："}
									value={
										list?.driver?.driver_phone ?? "未分配"
									}
								/>
							</div>
						</Card>
					</div>
					{/* <Divider /> */}
					<div>
						<Title level={5}>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									乘客信息{" "}
									<Tag color="volcano">
										{getClientNumber(list.items)}个人
									</Tag>
								</div>
								<div
									style={{
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									<div
										style={{
											display: "flex",
											justifyContent: "flex-end",
											flexDirection: "column",
											gap: "5px",
										}}
									>
										{messageStatue.map((m) => {
											return (
												<>
													<Tag color="orange">
														未发送：{m.unsent}
													</Tag>
													<Tag color="green">
														发送成功：
														{m.sent}
													</Tag>
													<Tag color="red">
														发送失败：{m.failed}
													</Tag>
												</>
											);
										})}
									</div>
								</div>
							</div>
						</Title>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "5px",
							}}
						>
							{list.items.map((item) => {
								return (
									<Card hoverable>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												gap: "5px",
											}}
										>
											<ItemText
												text={"名字："}
												value={`${item.client_name}`}
											/>
											<ItemText
												text={"人数："}
												value={item.people_no}
											/>
											<ItemText
												text={"电话："}
												value={item.client_phone}
											/>
											<ItemText
												text={"地址："}
												value={item.pickup_location}
											/>
											<ItemText
												text={"时间："}
												value={item.pickup_time}
											/>
											<Text>
												备注：{" "}
												<Text italic type="warning">
													{item.comment}
												</Text>
											</Text>
										</div>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												gap: "5px",
												marginBottom: "5px",
											}}
										>
											<Flex justify="flex-end">
												{item.is_msg === 0 && (
													<Tag color="grey">
														未发送
													</Tag>
												)}
												{item.is_msg === 1 && (
													<Tag color="green">
														已发送
													</Tag>
												)}
												{item.is_msg === 2 && (
													<Tag color="red">
														发送失败
													</Tag>
												)}
											</Flex>

											<Flex
												justify="flex-end"
												gap={"small"}
											>
												<Button
													size="small"
													onClick={() =>
														handleCopySMS(
															item,
															list.vehicle,
															list.driver
														)
													}
												>
													复制信息
												</Button>

												{(item.is_msg === 2 ||
													item.is_msg === 0) && (
														<Flex justify="flex-end">
															<ReSendMessageWithPhone
																item={{
																	allocation_uuid:
																		item.allocation_uuid,
																	template_id:
																		selectTemplate?.id,
																	client_phone:
																		item.client_phone,
																}}
																selectedDate={
																	selectedDate
																}
																mappingMessageDetail={() =>
																	mappingMessageDetail(
																		item,
																		list.vehicle,
																		list.driver
																	)
																}
															/>
														</Flex>
													)}
											</Flex>
										</div>
									</Card>
								);
							})}
						</div>
					</div>
				</div>
			</Card>
		</>
	);
};

function Result({ product, selectedDate }) {
	const allocationList = product.allocation_list;
	const { data: template } = useGetTemplatesQuery();
	const [selectTemplate, setSelectTemplate] = useState();
	const [sendMessages] = useSendMessagesMutation();

	const { refetch } = useGetAllocationByDateQuery(selectedDate);

	const handleSelectTemplate = (id) => {
		template?.forEach((t) => {
			if (t.id === id) {
				setSelectTemplate(t);
			}
		});
	};

	const handleSendMessages = async (isSendAll) => {
		await sendMessages({
			product_id: product.product_id,
			travel_date: selectedDate,
			template_id: selectTemplate.id,
			is_send_all: isSendAll,
		})
			.unwrap()
			.then((payload) => {
				console.log("payload", payload);
				if (payload.msg === "No message to send.") {
					message.warning("没有信息需要发送");
					refetch();
				} else if (payload.status.toUpperCase() === "SUCCESS") {
					message.success("发送信息成功");
					refetch();
				} else {
					message.error("发送信息失败");
				}
			})
			.catch((error) => message.error("Something went wrong..." + error));
	};

	return (
		<div>
			<Flex vertical style={{ marginBottom: 20 }} gap={"small"}>
				<Title level={5}>发送信息</Title>
				<Flex gap={"small"}>
					<Select
						style={{
							width: 200,
						}}
						defaultValue="Select phone template"
						options={
							template
								? template.map((t) => {
									const newT = { ...t };
									newT["label"] = t.name;
									newT["value"] = t.id;
									return newT;
								})
								: []
						}
						onChange={handleSelectTemplate}
					/>
					<Button
						disabled={selectTemplate == null}
						onClick={() => handleSendMessages(true)}
					>
						发送所有短信(含已成功)
					</Button>
					<Button
						disabled={selectTemplate == null}
						onClick={() => handleSendMessages(false)}
					>
						发送未发送的信息(不含已成功)
					</Button>
				</Flex>

				{selectTemplate && (
					<Alert
						message="已选择的模版"
						description={
							<div>
								{selectTemplate.template
									.split("\n")
									.map((line, index) => (
										<React.Fragment key={index}>
											{line}
											<br />
										</React.Fragment>
									))}
							</div>
						}
						type="success"
						showIcon
					/>
				)}
			</Flex>
			<Flex wrap="wrap" gap="small">
				{allocationList.map((list, index) => (
					<CardItem
						list={list}
						selectTemplate={selectTemplate}
						productTitle={{ product_title: product.product_title }}
						selectedDate={selectedDate}
					/>
				))}
			</Flex>
		</div>
	);
}

function DriverSummary({ driver = [] }) {
	const columns = [
		{
			title: "时间",
			dataIndex: "product_time",
			key: "product_time",
			editable: false,
		},
		{
			title: "项目",
			dataIndex: "product_title",
			key: "product_title",
			editable: true,
		},
		{
			title: "司机名字",
			dataIndex: "driver_name",
			key: "driver_name",
			editable: true,
		},
		{
			title: "司机电话",
			dataIndex: "driver_phone",
			key: "driver_phone",
			editable: true,
		},
	];

	const handleCopy = () => {
		let text = "时间, 项目, 司机名字, 司机电话\n";
		driver.forEach((d) => {
			text =
				text +
				`${d.product_time}, ${d.product_title}, ${d.driver_name}, ${d.driver_phone}\n`;
		});

		copy(text);
		message.success("已经复制接送汇总！");

		// navigator.clipboard
		// 	.writeText(text)
		// 	.then(() => {
		// 		message.success("已经复制司机汇总！");
		// 	})
		// 	.catch((err) => {
		// 		message.warning("Failed to copy");
		// 		console.error("Failed to copy: ", err);
		// 	});
	};
	return (
		<Card
			title="司机汇总"
			extra={<Button onClick={handleCopy}>复制</Button>}
		>
			<Table dataSource={driver} columns={columns} pagination={false} />
		</Card>
	);
}

function DriverPickupSummary({ pickup = [] }) {
	const getVehicleTextToCopy = (p, Url = true) => {
		if(Url) {
			return `http://aktravel.com.au/bus-detail/${p.vehicle_plate_number}`;
		}
		const clients = p.client
			.map((c) => {
				const addressPart = c.pickup_address ? ` (${c.pickup_address})` : "";
				const shortName = c.user_short_name ? `渠道【${c.user_short_name}】,` : "";
				return ` - 客户【${c.client_name}】, 客户电话【${c.client_phone}】, 接送地点【${c.pickup_location}${addressPart}】, 接送时间【${c.pickup_time}】, 人数【${c.people_no}】, ${shortName} 备注【${c.comment}】`;
			})
			.join("\n\n");

		return `车辆：【${p.vehicle_plate_number}】，总人数：【${p.people_no}人】，项目：${p.product_title}\n - 司导：【${p.driver_name}】，司导电话：【${p.driver_phone}】\n\n${clients}`;
	};

	const handleCopyVehicle = (p, Url = false) => {
		const text = getVehicleTextToCopy(p, Url);
		copy(text);
		message.success(Url ? "已经复制链接！" : "已经复制这辆车接送汇总！");

		// navigator.clipboard
		// 	.writeText(text)
		// 	.then(() => {
		// 		message.success("已经复制接送汇总！");
		// 	})
		// 	.catch((err) => {
		// 		message.warning("Failed to copy");
		// 		console.error("Failed to copy: ", err);
		// 	});
	};

	const handleCopy = () => {
		const text = pickup.map((p) => getVehicleTextToCopy(p)).join("\n\n");
		copy(text);
		message.success("已经复制接送汇总！");
	};

	return (
		<Card
			title="接送汇总"
			extra={<Button onClick={handleCopy}>复制全部</Button>}
		>
			<div className="driver-pickup-summary-list">
				{pickup.map((p, pickupIndex) => {
					return (
						<Card
							key={`${p.vehicle_plate_number || "vehicle"}-${p.product_title || pickupIndex}`}
							title={
								<Flex align="center" gap={8} wrap="wrap">
									<span>车辆：【{p.vehicle_plate_number}】</span>
									<Tag color="blue">总人数 {p.people_no} 人</Tag>
									<Tag>{p.product_title}</Tag>
								</Flex>
							}
							extra={
								<Flex gap={8} wrap="wrap">
									<Button onClick={() => handleCopyVehicle(p, false)}>
										复制文本
									</Button>
									<Button onClick={() => handleCopyVehicle(p, true)}>
										复制链接
									</Button>
								</Flex>
							}
						>
							<div>
								车辆：【{p.vehicle_plate_number}】，总人数【
								{p.people_no}人】，项目：{p.product_title}，链接：http://aktravel.com.au/bus-detail/{p.vehicle_plate_number}
								<ul>
									<li>
										司导：【{p.driver_name}】，司导电话：【
										{p.driver_phone}】
										<br />
										<br />
									</li>
									{p.client.map((c, index) => {
										const shortName = c.user_short_name ? `渠道【${c.user_short_name}】, ` : "";
										return (
											<li
												key={c.allocation_uuid || c.order_sub_id || index}
											>
												客户【{c.client_name}】, 客户电话【
												{c.client_phone}】, 接送地点【
												{c.pickup_location} {c.pickup_address && ` (${c.pickup_address})`}】, 接送时间【
												{c.pickup_time}】, 人数【
												{c.people_no}】, {shortName} 备注【
												{c.comment}】
												<br />
												<br />
											</li>
										);
									})}
								</ul>
							</div>
						</Card>
					);
				})}
			</div>
		</Card>
	);
}

function SummaryToDisplay({ summary = [] }) {
	// const getTextToCopy = () => {
	// 	return summary
	// 		.map((p) => {
	// 			let pickups = p.pickup
	// 				.map((pickup) => {
	// 					let clients = pickup.clients
	// 						.map((client) => `【${client}】`)
	// 						.join(", ");
	// 					return `接送时间【${pickup.pickup_time}】，接送地点【${
	// 						pickup.pickup_location
	// 					}】，人数【${pickup.people_no}人】${
	// 						clients ? `\n${clients}` : ""
	// 					}`;
	// 				})
	// 				.join("\n");
	// 			return `${p.product_title}, 人数:【${p.people_no}】\n车辆：【${p.vehicle_plate_number}】\n司导：【${p.driver_name}】\n电话：【${p.driver_phone}】\n${pickups}`;
	// 		})
	// 		.join("\n\n");
	// };

	const getTextToCopy = () => {
		return summary
			.map((productGroup, groupIndex) => {
				let groupText = productGroup
					.map((p, productIndex) => {
						let pickups = p.pickup
							.map((pickup) => {
								let clients = pickup.clients
									.map((client) => `【${client}】`)
									.join(", ");
								let pickupAddress = pickup.pickup_address ? ` (${pickup.pickup_address})` : "";
								return `接送时间【${pickup.pickup_time}】，接送地点【${pickup.pickup_location}${pickupAddress}】${clients ? `\n${clients}\n` : ""}`;
							})
							.join("\n");
						let productText = `${p.product_title}, 人数:【${p.people_no}】\n车辆：【${p.vehicle_plate_number}】\n司导：【${p.driver_name}】\n电话：【${p.driver_phone}】\n\n${pickups}`;
						if (
							productGroup.length !== productIndex + 1 &&
							productGroup.length > 1
						) {
							productText +=
								"\n\n=============================================================";
						}
						return productText;
					})
					.join("\n\n");

				if (groupIndex === 0) {
					return `\n${groupText}\n`;
				} else {
					return `------------------------------------------------------------------------------------------\n\n${groupText}\n`;
				}
			})
			.join("\n");
	};

	const handleCopy = () => {
		let text = getTextToCopy();
		copy(text);
		message.success("已经复制接送汇总！");
		// navigator.clipboard
		// 	.writeText(text)
		// 	.then(() => {
		// 		message.success("已经复制接送汇总！");
		// 	})
		// 	.catch((err) => {
		// 		message.warning("Failed to copy");
		// 		console.error("Failed to copy: ", err);
		// 	});
	};

	return (
		<Card title="大汇总" extra={<Button onClick={handleCopy}>复制</Button>}>
			{summary.map((productGroup, groupIndex) => (
				<div key={groupIndex} style={{ marginBottom: "20px" }}>
					{groupIndex !== 0 ? (
						<div style={{ paddingBottom: 5 }}>
							------------------------------------------------------------------------------------------
						</div>
					) : (
						<></>
					)}
					{productGroup.map((product, productIndex) => {
						return (
							<>
								<div
									key={productIndex}
									style={{ paddingTop: 5 }}
								>
									{product.product_title}, 人数:【
									{product.people_no}】
									<ul>
										<div>
											车辆：【
											{product.vehicle_plate_number}】
										</div>
										<div>
											司导：【{product.driver_name}】
										</div>
										<div>
											电话：【{product.driver_phone}】
										</div>
										<div>
											{product.pickup.map(
												(pickup, pickupIndex) => (
													<li key={pickupIndex}>
														接送时间【
														{pickup.pickup_time}
														】，接送地点【
														{
															pickup.pickup_location
														}{" "}
														{pickup.pickup_address && `(${pickup.pickup_address})`}】
														<ul>
															{pickup.clients.map(
																(
																	client,
																	clientIndex
																) => (
																	<li
																		key={
																			clientIndex
																		}
																	>
																		【
																		{client}
																		】
																	</li>
																)
															)}
														</ul>
													</li>
												)
											)}
										</div>
									</ul>
								</div>
								{productGroup.length !== productIndex + 1 &&
									productGroup.length > 1 &&
									"============================================================="}
							</>
						);
					})}
				</div>
			))}
		</Card>
	);
	// return (
	// 	<Card title="大汇总" extra={<Button onClick={handleCopy}>复制</Button>}>
	// 		{summary.map((p) => {
	// 			currentProductTitle.push(currentProductTitle);
	// 			return (
	// 				<div>
	// 					{p.product_title}, 人数:【{p.people_no}】
	// 					<ul>
	// 						<div>车辆：【{p.vehicle_plate_number}】</div>
	// 						<div>司导：【{p.driver_name}】</div>
	// 						<div>电话：【{p.driver_phone}】</div>
	// 						<div>
	// 							{p.pickup.map((p) => {
	// 								return (
	// 									<li>
	// 										接送时间【{p.pickup_time}】，
	// 										接送地点【{p.pickup_location}】，
	// 										人数【{p.people_no}人】
	// 										<ul>
	// 											{p.clients.map((c) => (
	// 												<li>【{c}】</li>
	// 											))}
	// 										</ul>
	// 									</li>
	// 								);
	// 							})}
	// 						</div>
	// 					</ul>
	// 				</div>
	// 			);
	// 		})}
	// 	</Card>
	// );
}

function CustomSendMessage({ selectedDate }) {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);

	const [sendCsutomMessage] = useSendCsutomMessageMutation();
	const { refetch } = useGetAllocationByDateQuery(selectedDate);

	const onFinish = async (values) => {
		await sendCsutomMessage({
			...values,
		})
			.unwrap()
			.then((payload) => {
				setIsOpen(false);
				if (payload.message === "SUCCESS") {
					message.success("发送信息成功");
					form.resetFields();
					setIsOpen(false);
					refetch();
				} else {
					message.error("发送信息失败");
				}
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<>
			<Button
				style={{ marginLeft: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				发送自定义信息
			</Button>
			<Modal
				title="发送信息"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="80%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: "80%", marginTop: "30px" }}
				>
					<Form.Item
						name="client_phone"
						label="电话"
						rules={[{ required: true, message: "请输入电话" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="context"
						label="短信内容"
						rules={[{ required: true, message: "请输入短信内容" }]}
					>
						<Input.TextArea rows={10} />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}
function ReSendMessageWithPhone({ item, selectedDate, mappingMessageDetail }) {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);
	// const [mappingSms, setMappingSms] = useState("");
	//const [sendMessageWithPhone] = useSendMessageWithPhoneMutation();
	const [sendMessageWithPhone] = useSendMessageWithCusPhoneUpdatedMutation();
	const { refetch } = useGetAllocationByDateQuery(selectedDate);

	const onFinish = async (values) => {
		await sendMessageWithPhone({
			...values,
			allocation_uuid: item.allocation_uuid,
			//template_id: item.template_id,
		})
			.unwrap()
			.then(async (payload) => {
				if (payload.message === "SUCCESS") {
					message.success("发送信息成功");
					form.resetFields();
					setIsOpen(false);
					await refetch();
				} else {
					message.error("发送信息失败");
					setIsOpen(false);
					await refetch();
				}
			})
			.catch((error) => message.error("Something went wrong..."));

		//setMappingSms("");
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
		//setMappingSms("");
	};

	useEffect(() => {
		form.setFieldsValue(item); // 确保每次 item 更新时，更新表单的字段值
	}, [form, item]);

	const handleOnClick = () => {
		if (item.template_id == null) {
			message.warning("Please select template");
			return;
		}

		const text = mappingMessageDetail();
		form.setFieldsValue({ context: text });
		// setMappingSms(text);
		setIsOpen(true);
	};
	return (
		<>
			<Button size="small" onClick={handleOnClick} type="primary">
				发送信息
			</Button>
			<Modal
				title="发送信息"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="80%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: "80%", marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="client_phone"
						label="电话"
						rules={[{ required: true, message: "请输入电话" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="context"
						label="短信内容"
						rules={[{ required: true, message: "请输入短信内容" }]}
					>
						<Input.TextArea rows={10} />
						{/* <div>{mappingSms}</div> */}
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}

function ResultPage() {
	const [selectedDate, setSelectedDate] = useState(
		dayjs().format(dateFormat)
	);
	const [activeKey, setActiveKey] = useState(["0"]);
	const [activeKeySummary, setActiveKeySummary] = useState(["0"]);

	const { data, isLoading, isError } =
		useGetAllocationByDateQuery(selectedDate);
	// useGetAllocationByDateQuery("2024-04-26");

	const { data: releaseData, refetch: refetchReleaseData } = useGetReleaseByDateQuery(selectedDate);

	const [addNewRelease] = useAddReleaseMutation();
	const [updateRelease] = useUpdateReleaseMutation();

	const items = data
		? data.product_list.map((d, index) => {
			return {
				key: index,
				label: d.product_title,
				children: (
					<Result product={d} selectedDate={selectedDate} />
				),
			};
		})
		: [];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <Alert type="error" message="Something went wrong" />;
	}

	const getDriverSummary = (productList) => {
		const driver = productList.map((product) => {
			return product.allocation_list.map((list) => {
				return {
					product_title: product.product_title,
					product_time: selectedDate,
					driver_name: list.driver.driver_name,
					driver_phone: list.driver.driver_phone,
				};
			});
		});
		return driver.flat();
	};

	const getDriverPickupSummary = (productList) => {
		const info = productList.map((product) => {
			return product.allocation_list.map((list) => {
				return {
					product_title: product.product_title,
					product_time: selectedDate,
					vehicle_plate_number: list.vehicle.vehicle_plate_number,
					driver_phone: list.driver.driver_phone,
					driver_name: list.driver.driver_name,
					people_no: list.items.reduce((c, a) => c + a.people_no, 0),
					client: list.items.map((item) => ({
						client_name: item.client_name,
						pickup_time: item.pickup_time,
						pickup_location: item.pickup_location,
						pickup_address: item.pickup_address,
						client_phone: (item.client_phone.startsWith("61") || item.client_phone.startsWith("86")) ? ("+" + item.client_phone) : item.client_phone,
						people_no: item.people_no,
						comment: item.comment,
						user_name: item.user_name,
						user_short_name: item.user_short_name,
					})),
				};
			});
		});
		return info.flat();
	};

	const getSummaryToDisplay = (productList) => {
		const info = productList.map((product) => {
			return product.allocation_list.map((list) => {
				const groupedOrders = {};
				// 遍历原始数组并分组
				list.items.forEach((order) => {
					const key = order.pickup_location;
					if (!groupedOrders[key]) {
						groupedOrders[key] = {
							pickup_time: order.pickup_time,
							pickup_location: order.pickup_location,
							pickup_address: order.pickup_address,
							clients: [order.client_name],
							people_no: order.people_no,
						};
					} else {
						groupedOrders[key].clients.push(order.client_name);
					}
				});

				// 将对象转换为数组
				const result = Object.values(groupedOrders);
				return {
					product_id: product.product_id,
					product_title: product.product_title,
					product_time: selectedDate,
					vehicle_plate_number: list.vehicle.vehicle_plate_number,
					driver_phone: list.driver.driver_phone,
					driver_name: list.driver.driver_name,
					pickup: result,
					people_no: list.items.reduce((c, a) => c + a.people_no, 0),
					client: list.items.map((item) => ({
						client_name: item.client_name,
						pickup_time: item.pickup_time,
						pickup_location: item.pickup_location,
						client_phone: item.client_phone,
						people_no: item.people_no,
					})),
				};
			});
		});
		const data = info.flat();

		// Create a map to group products by their title and time
		const groupedProducts = {};

		data.forEach((product) => {
			const key = `${product.product_title} - ${product.product_time}`;
			if (!groupedProducts[key]) {
				groupedProducts[key] = [];
			}
			groupedProducts[key].push(product);
		});

		// Convert the grouped products into the desired format
		const result = Object.values(groupedProducts);

		return result;
		// return info.flat();
	};

	const handleToggle = () => {
		if (activeKey.length === 0) {
			// 如果当前全部折叠，则展开所有项
			setActiveKey(["0", "1", "2"]); // 根据实际情况列出所有的Panel key
		} else {
			// 如果当前有展开项，则折叠所有项
			setActiveKey([]);
		}
	};
	const handleToggleSummary = () => {
		if (activeKeySummary.length === 0) {
			// 如果当前全部折叠，则展开所有项
			setActiveKeySummary(["0", "1", "2"]); // 根据实际情况列出所有的Panel key
		} else {
			// 如果当前有展开项，则折叠所有项
			setActiveKeySummary([]);
		}
	};

	const handleNewRelease = async () => {
		const requestData = {
			"release_date": selectedDate,
			"release_status": true
		};
		try {
			const result = await addNewRelease(requestData);
			refetchReleaseData();
			message.success("发布成功!");
		}
		catch (error) {
			console.log(error);
			message.warning("发布失败!请刷新后重新尝试!");
		}
	}

	const handleUpdateRelease = async () => {
		const requestData = {
			"release_date": selectedDate,
			"release_status": !releaseData.release_status
		};
		try {
			const result = await updateRelease(requestData);
			message.success(!releaseData.release_status ? "发布成功!" : "取消发布成功");
			refetchReleaseData();
		}
		catch (error) {
			console.log(error);
			message.warning("发布失败!请刷新后重新尝试!");
		}
	}

	return (
		<>
			<Row gutter={[16, 16]}>
				<Col span={12}>
					<DatePicker
						style={{
							width: "200px",
							marginBottom: "30px",
						}}
						defaultValue={dayjs(selectedDate, dateFormat)}
						format={dateFormat}
						onChange={(date, dateString) => {
							setSelectedDate(dateString);
						}}
						allowClear={false}
					/>
					<CustomSendMessage selectedDate={selectedDate} />
				</Col>

				<Col span={6} offset={6} style={{ display: 'flex', justifyContent: 'end' }}>
					{releaseData === null ?
						(<>
							<Title level={4} style={{ marginRight: 10 }}>未发布</Title>
							<Button onClick={handleNewRelease}> 发布到Summary </Button>
						</>)
						: (releaseData?.release_status ?
							(<>
								<Title level={4} style={{ marginRight: 10 }}>已发布</Title>
								<Button onClick={handleUpdateRelease}> 取消发布 </Button>
							</>) :
							(<>
								<Title level={4} style={{ marginRight: 10 }}>未发布</Title>
								<Button onClick={handleUpdateRelease}> 发布到Summary </Button>
							</>)
						)
					}
				</Col>
			</Row>


			{data?.product_list?.length === 0 && (
				<Alert message="No Data" type="info" />
			)}

			{data?.product_list?.length > 0 && (
				<Flex vertical gap={"large"}>
					<div>
						<Button
							onClick={handleToggleSummary}
							style={{ marginBottom: "10px" }}
						>
							{activeKeySummary.length === 0
								? "全部展开汇总"
								: "全部折叠汇总"}
						</Button>
						<Collapse
							items={[
								{
									key: 0,
									label: "司机汇总",
									children: (
										<DriverSummary
											driver={getDriverSummary(
												data.product_list
											)}
										/>
									),
								},
								{
									key: 1,
									label: "接送汇总",
									children: (
										<DriverPickupSummary
											pickup={getDriverPickupSummary(
												data.product_list
											)}
										/>
									),
								},
								{
									key: 2,
									label: "大汇总",
									children: (
										<SummaryToDisplay
											summary={getSummaryToDisplay(
												data.product_list
											)}
										/>
									),
								},
							]}
							activeKey={activeKeySummary}
							defaultActiveKey={["0"]}
							onChange={setActiveKeySummary}
						/>
					</div>

					<div>
						<Button
							onClick={handleToggle}
							style={{ marginBottom: "10px" }}
						>
							{activeKey.length === 0
								? "全部展开行程"
								: "全部折叠行程"}
						</Button>
						<Collapse
							items={items}
							activeKey={activeKey}
							onChange={setActiveKey}
							defaultActiveKey={["0"]}
						/>
					</div>
				</Flex>
			)}
		</>
	);
}

export default ResultPage;
